import { render, staticRenderFns } from "./PaymentSuccessfulPage.vue?vue&type=template&id=620dfd11&scoped=true"
import script from "./PaymentSuccessfulPage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessfulPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessfulPage.vue?vue&type=style&index=0&id=620dfd11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dfd11",
  null
  
)

export default component.exports